import { useState, useEffect } from 'react';
import axios from 'axios';
import BASE_API_URL from 'const';

export default function useValidateEmailExists(email, debounceTime = 450) {
  const [emailExists, setEmailExists] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const isEmailValid = (email) => email.match(/^\S+@\S+\.\S+$/);

  useEffect(() => {
    let timeoutId;

    async function checkEmailExists() {
      setIsLoading(true);

      try {
        const response = await axios.get(
          `${BASE_API_URL}/users/filter/?email=${email}`,
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data.length > 0) {
          setEmailExists(true);
          setEmailList(response.data);
        }
      } catch (error) {
        console.error(error);
      }

      setIsLoading(false);
    }

    if (email && isEmailValid(email)) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => checkEmailExists(), debounceTime);
    }

    return () => {
      setEmailExists(false);
      setIsLoading(false);
      clearTimeout(timeoutId);
    };
  }, [email, debounceTime]);

  return [emailExists, emailList, isLoading];
};
